import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconProfile = memo(({ color = '#545454', size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        d="M12 1C5.925 1 1 5.925 1 12A11 11 0 1012 1zM6.577 18.908c.473-.99 3.355-1.958 5.423-1.958s4.95.968 5.423 1.958A8.682 8.682 0 0112 20.8a8.682 8.682 0 01-5.423-1.892zm12.419-1.595c-1.573-1.914-5.39-2.563-6.996-2.563-1.606 0-5.423.649-6.996 2.563A8.72 8.72 0 013.2 12c0-4.851 3.949-8.8 8.8-8.8 4.851 0 8.8 3.949 8.8 8.8a8.72 8.72 0 01-1.804 5.313zM12 5.4a3.84 3.84 0 00-3.85 3.85A3.84 3.84 0 0012 13.1a3.84 3.84 0 003.85-3.85A3.84 3.84 0 0012 5.4zm0 5.5a1.65 1.65 0 110-3.3 1.65 1.65 0 010 3.3z"
      />
    </Svg>
  );
});
